import { ErrorBoundary as SentryErrorBoundary, type FallbackRender } from "@sentry/react";
import type { ReactElement, ReactNode } from "react";

type ErrorBoundaryProps = {
  children?: ReactNode;
  fallback?: ReactElement | FallbackRender;
};

const ErrorBoundary = ({ children, fallback }: ErrorBoundaryProps) => {
  return <SentryErrorBoundary fallback={fallback}>{children}</SentryErrorBoundary>;
};

export default ErrorBoundary;
